<template>
  <div class="card-wrap">
    <!-- <el-button @click="add()">内部Add: {{ num }} </el-button> -->
    <el-button
      class="add"
      icon="el-icon-search"
      size="mini"
      circle
    ></el-button>
    <el-tooltip
      class="item"
      effect="dark"
      content="Top Left 提示文字"
      placement="top-start"
    >
      <h1>{{ title }}</h1>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'Count',
  inject: ['getGraph', 'getNode'],
  data () {
    return {
      num: 0,
      title: ''
    }
  },
  mounted () {
    const self = this
    const node = this.getNode()
    console.log(node)
    this.title = node.data.title
    // 监听数据改变事件
    node.on('change:data', ({ current }) => {
      self.num = current.num
      self.title = current.title
    })
  },
  methods: {
    add () {
      const node = this.getNode()
      console.log(node)
      console.log(this.getGraph())
      console.log(node.getData())
      const { num } = node.getData()
      node.setData({
        num: num + 1
      })
    },
    format (percentage) {
      return percentage === 100 ? '满' : `${percentage}%`
    }
  }
}
</script>

<style scoped lang="stylus">
.card-wrap
  border: 1px solid #ccc
  height: 100%
  width 100%
  position relative
  box-sizing: border-box
  padding 10px
.add
  position: absolute
  bottom: -10%
  left: 50%
  margin auto
  transform: translateX(-50%)
</style>
